"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProtectionService = void 0;
const operators_1 = require("rxjs/operators");
const restservice_1 = require("./restservice");
const http_1 = require("@angular/common/http");
class ProtectionService extends restservice_1.RestService {
    constructor() {
        super(...arguments);
        this.listEligibility = '/rest-api/account/insurance/v3/eligibility';
        this.getInsuranceTiersUrl = '/rest-api/account/insurance/v3/tiers';
        this.enrollWHPInsuranceEndpoint = '/rest-api/account/insurance/v1/enrollWHP';
        this.unenrollWHPInsuranceEndpoint = '/rest-api/account/insurance/v1/unenrollWHP/';
        this.getActiveInsuranceEnpoint = '/rest-api/account/insurance/v1/getActiveWHP';
    }
    getListEligibility() {
        return this.get(this.listEligibility).pipe(operators_1.map((res) => res), operators_1.catchError((error) => {
            const obj = error;
            throw obj;
        }));
    }
    getTierDetails() {
        return this.get(this.getInsuranceTiersUrl).pipe(operators_1.map((res) => res), operators_1.catchError((error) => {
            const obj = error;
            throw obj;
        }));
    }
    enrollWholeHomeProtection(lobRequest) {
        const formData = new http_1.HttpParams().set('lineOfBusiness', lobRequest);
        return this.post(this.enrollWHPInsuranceEndpoint, formData).pipe(operators_1.map((res) => res), operators_1.catchError((error) => {
            throw error;
        }));
    }
    unenrollWholeHomeProtection(protectionId) {
        return this.delete(this.unenrollWHPInsuranceEndpoint + protectionId).pipe(operators_1.map((res) => res), operators_1.catchError((error) => {
            throw error;
        }));
    }
    getActiveInsurance() {
        return this.get(this.getActiveInsuranceEnpoint).pipe(operators_1.map((res) => res), operators_1.catchError((error) => {
            const obj = error;
            throw obj;
        }));
    }
}
exports.ProtectionService = ProtectionService;
//# sourceMappingURL=protection.service.js.map